import { LlmModelName } from 'llm-model-registry';
import { z } from 'zod';

import { BaseFlowBlockSchema, BlockType } from '../base/baseSchema.js';

export const ExtractableEntitySchema = z.object({
  name: z.string().min(1, 'Field name is required and cannot be empty'),
  description: z.string().default(''),
});
export type ExtractableEntity = z.infer<typeof ExtractableEntitySchema>;

export const ExtractionExampleSchema = z.object({
  input: z.string().default(''),
  output: z.string().default(''),
});
export type ExtractionExample = z.infer<typeof ExtractionExampleSchema>;

export const InformationExtractionBlockConfigSchema = z.object({
  documents: z.string().min(1, 'Input documents are required'),
  extractionFields: z
    .array(ExtractableEntitySchema)
    .min(1, 'At least one extraction field must be defined'),
  examples: z.array(ExtractionExampleSchema).optional().default([]),
  additionalPrompt: z.string().optional(),
  rankingPrompt: z.string().optional(),
  modelName: z.nativeEnum(LlmModelName).default(LlmModelName.notable_default),
});
export type InformationExtractionBlockConfig = z.infer<
  typeof InformationExtractionBlockConfigSchema
>;

export const InformationExtractionBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.InformationExtraction),
  config: InformationExtractionBlockConfigSchema,
});
export type InformationExtractionBlock = z.infer<typeof InformationExtractionBlockSchema>;
